import template from './print_checkout.html';
import controller from './print_checkout.controller';
import './print_checkout.scss';

let printCheckoutComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default printCheckoutComponent;


// WEBPACK FOOTER //
// ./client/app/components/checkout/print/print_checkout.component.js